import SmsDirection from '../../../domain/sms/smsDirection'
import SmsStatus from '../../../domain/sms/smsStatus'
import { adminHttpClient } from '../../commons/adminHttpClient'
import PagedList from '../../commons/pagedList'

export type SearchSmsFilter = {
  pageNumber: number
  pageSize: number
  orderColumn: string
  orderDescending: boolean
  q?: string
  lastXDays: number
  filter: string
}

export type SearchSmsItemResponse = {
  companyUserId?: string
  sendDate?: string
  firstName: string
  lastName: string
  direction: SmsDirection
  phoneNumber: string
  messageBody: string
  status: SmsStatus
}

export const searchSmsMessages = (filter: SearchSmsFilter): Promise<PagedList<SearchSmsItemResponse>> => {
  filter = filter || {
    pageNumber: 1,
    pageSize: 25,
    orderColumn: 'sendDate',
    orderDescending: true,
  }

  return adminHttpClient.get('adminDashboard/messages/sms-messages', filter)
}
